let mainProductEl = document.querySelector('product-info .product')
let pdpSalePriceContainer = document.querySelector('[data-main-product-price] .price__sale')
let pdpRegularPriceContainer = document.querySelector('[data-main-product-price] .price__regular')
let pdpSalePriceItemEls = document.querySelectorAll(`[data-main-product-price] .price__sale .price-item.price-item--sale,
                                                     [data-main-product-price] .price__regular .price-item.price-item--regular`)
let pdpComparePriceItemEls = document.querySelectorAll('[data-main-product-price] .price__sale .price-item.price-item--regular')
let pdpSavingsEls = document.querySelectorAll('[data-main-product-price] .lj-price-savings')
let pdpSavingsMoneyEls = document.querySelectorAll('[data-main-product-price] .lj-price-savings__money');
let pdpSavingsPercentageEls = document.querySelectorAll('[data-main-product-price] .lj-price-savings__percentage');

let mainProductPriceEl = document.querySelector('.product [data-main-product-price]')
let mainProductSalePrice = mainProductPriceEl.getAttribute('data-product-sale-price')
let mainProductComparePrice = mainProductPriceEl.getAttribute('data-product-compare-price')
let mainProductQuantityEl = mainProductEl.querySelector('quantity-input.quantity input');
let mainProductQuantity;

let upsellCheckboxes = document.querySelectorAll('.lj-pdp-upsells-product-checkbox__checkbox')
let upsellsComparePrice = '';
let upsellsSalePrice = '';

let upsellItems = [];

let pdpATCEls = document.querySelectorAll('.product .product-form__buttons button[name="add"]');

// ----------------------------
// initialising the needed events
function initUpsellEvents() {
  if (upsellCheckboxes) {
    upsellCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener('input', () => {
        console.log("pdp-price:update")
        document.dispatchEvent(new CustomEvent('pdp-price:update'))
      })
    })
  }

  if (pdpATCEls) {
    // pdpATCEls.forEach((btn) => {
    //   btn.addEventListener('click', (e) => {
    //     setTimeout(atcUpsellsArrayCheck, 1000)
    //   })
    // })
  }

  if (mainProductQuantityEl) {
    mainProductQuantityEl.addEventListener('change', (e) => {
      document.dispatchEvent(new CustomEvent('pdp-price:update'))
    })
  }
}

// ----------------------------
// refreshing variable because of new fetched seciton block using AJAX.
function updateVariables() {
  pdpSalePriceContainer = document.querySelector('[data-main-product-price] .price__sale')
  pdpRegularPriceContainer = document.querySelector('[data-main-product-price] .price__regular')
  pdpSalePriceItemEls = document.querySelectorAll(`[data-main-product-price] .price__sale .price-item.price-item--sale,
                                                   [data-main-product-price] .price__regular .price-item.price-item--regular`)
  pdpComparePriceItemEls = document.querySelectorAll('[data-main-product-price] .price__sale .price-item.price-item--regular')
  pdpSavingsEls = document.querySelectorAll('[data-main-product-price] .lj-price-savings')
  pdpSavingsMoneyEls = document.querySelectorAll('[data-main-product-price] .lj-price-savings__money')
  pdpSavingsPercentageEls = document.querySelectorAll('[data-main-product-price] .lj-price-savings__percentage')

  
  mainProductPriceEl = document.querySelector('.product [data-main-product-price]')
  mainProductSalePrice = +mainProductPriceEl.getAttribute('data-product-sale-price')
  mainProductComparePrice = +mainProductPriceEl.getAttribute('data-product-compare-price')
  
  upsellsComparePrice = 0
  upsellsSalePrice = 0

  mainProductQuantityEl = mainProductEl.querySelector('quantity-input.quantity input');
  if (mainProductQuantityEl) {
    mainProductQuantityEl.addEventListener('change', (e) => {
      console.log('quantity changed')
      document.dispatchEvent(new CustomEvent('pdp-price:update'))
    })
  }
}

// ----------------------------
// calculating price based on upsell selected and variant selected
function calculatePrices() {
  upsellCheckboxes.forEach((checkbox) => {
    if (checkbox.checked) {
      upsellsComparePrice += +checkbox.getAttribute('data-upsell-compare-price')
      upsellsSalePrice += +checkbox.getAttribute('data-upsell-sale-price')
    }
  })
  
  if (mainProductQuantityEl) {
    mainProductQuantity = +mainProductQuantityEl.value
  }
  
  if (mainProductQuantity && !isNaN(mainProductQuantity)) {
    totalComparePrice = (mainProductComparePrice * mainProductQuantity) + upsellsComparePrice
  } else {
    totalComparePrice = mainProductComparePrice + upsellsComparePrice
  }
  
  if (mainProductQuantity && !isNaN(mainProductQuantity)) {
    totalSalePrice = (mainProductSalePrice * mainProductQuantity) + upsellsSalePrice
  } else {
    totalSalePrice = mainProductSalePrice + upsellsSalePrice
  }
  
  totalSavingsPrice = totalComparePrice - totalSalePrice
  totalSavingsPercentage = (((totalComparePrice - totalSalePrice) * 100) / totalComparePrice)
}

// ----------------------------
// rendering the price in the DOM Main Product section.
function renderPrices() {
  pdpSalePriceItemEls.forEach(el => el.textContent = formatMoney({cents: totalSalePrice, addCurrency: false}))
  pdpComparePriceItemEls.forEach(el => el.textContent = formatMoney({cents: totalComparePrice, addCurrency: false}))
  pdpSavingsMoneyEls.forEach(el => el.textContent = formatMoney({cents: totalSavingsPrice, addCurrency: false}))
  pdpSavingsPercentageEls.forEach(el => el.textContent = `(${Math.floor(totalSavingsPercentage)}%)`)
  
  if (totalSavingsPrice <= 0) {
    pdpSavingsEls.forEach(el => el.style.opacity = `1`)
    pdpSalePriceContainer.style.display = 'none'
    pdpRegularPriceContainer.style.display = 'flex'
  } else {
    pdpSavingsEls.forEach(el => el.style.opacity = `1`)
    pdpSalePriceContainer.style.display = 'flex'
    pdpRegularPriceContainer.style.display = 'none'
  }
}

// ----------------------------
// main function to update prices
function pdpPriceUpdateFn() {
  updateVariables()
  calculatePrices()
  renderPrices()
}

// ----------------------------
// check the selected upsells
function atcUpsellsArrayCheck() {
  upsellItems = [];
  
  upsellCheckboxes.forEach(checkbox => {
    if (checkbox.checked) {
      const variantId = parseInt(checkbox.dataset.variantId);
      const quantity = parseInt(checkbox.dataset.quantity || '1'); 
  
      if (variantId) {
        upsellItems.push({
          id: variantId,
          quantity: quantity
        });
      }
    }
  });

  if (upsellItems.length > 0){
    atcUpsellsATCFn(upsellItems)
  }
}

// ----------------------------
// send request of the checked upsells
function atcUpsellsATCFn(upsellItems) {
  if (upsellItems) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: upsellItems
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Cart updated:', data);
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
    });
  }
}  

// ----------------------------
// format money function to format the price, 'money_format' needs to be set in 'theme.liquid'
function formatMoney({
        cents,
        money_format = Shopify.money_format,
        active_currency = Shopify.currency.active,
        use_comma_cents = true,
        addCurrency = true
      }
    ) {
      let value = (cents / 100).toFixed(2);
      if (use_comma_cents) {
        value = value.replaceAll(".", ",");
      }

      let formatedMoney;
      if (money_format.includes("{{amount}}")) {
        formatedMoney = money_format.replace("{{amount}}", value);
      } else if (money_format.includes("{{amount_with_comma_separator}}")) {
        formatedMoney = money_format.replace(
          "{{amount_with_comma_separator}}",
          value
        );
      }

      if (addCurrency) {
        formatedMoney = formatedMoney + ` ${active_currency}`;
      } else {
        formatedMoney = formatedMoney;
      }

      return formatedMoney;
}


document.addEventListener('pdp-price:update', () => {
  pdpPriceUpdateFn()
});
if (mainProductEl) {
  initUpsellEvents()  
  document.dispatchEvent(new CustomEvent('pdp-price:update'))
}


if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", () => {
    document.addEventListener('pdp-price:update', () => {
      pdpPriceUpdateFn()
    });

    initUpsellEvents()  
    document.dispatchEvent(new CustomEvent('pdp-price:update'))
    
  });
}

// ----------------------------
// update the header cart bubble based upon app drawer bubble
function observeCartBadgeChange() {
  const target = document.querySelector('.qsc2-drawer-header__badge');
  const cartBubble = document.querySelector('.cart-count-bubble');

  if (!target || !cartBubble) return;

  const observer = new MutationObserver((mutationsList) => {
    for (let mutation of mutationsList) {
      if (
        mutation.type === 'characterData' ||
        mutation.type === 'childList'
      ) {
        const newCount = target.textContent.trim();
        cartBubble.textContent = newCount;
      }
    }
  });

  observer.observe(target, {
    characterData: true,
    childList: true,
    subtree: true
  });
}
document.addEventListener('DOMContentLoaded', () => {
  observeCartBadgeChange();
  setTimeout(observeCartBadgeChange, 3000)
});